import appInfo from "../app-info";
import { call_post_api } from "./api_helper"

export const dictionaryApi={
    select_all:()=>{
        return call_post_api(appInfo.api_url + '/uf_dictionary/select_all');
    }
}